export default __webpack_public_path__ + "static/media/F1_7.4fcd17bf.png";